const B_1 = [
    {
        title: '评价统计',
        path: '/bidding/projectflow/dingbiao/evaluateaccount/list'
    }
]
export default {
    path: 'evaluateaccount',
    component: () => import(/*webpackChunkName: 'bidding-ding-cjyygl'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/evaluateaccount/list'),
            meta: {
                title: '评价统计',
                bread: B_1
            },
        },
    ]
}